import { useQuery } from "@tanstack/vue-query";
import { type Ref } from "vue";
import { api } from "@/api";
import { type BaseReportFilters } from "./reports";

export const REPORT_HEATMAP_QUERY_KEY = "heatmap-report";

export type HeatmapPitchRow = {
  pitchId: string;
  name: string;
  mapX: number;
  mapY: number;
  pitchType: string;
  daysOccupied: number;
  periodDays: number;
  occupancyPct: number;
};

export const retrieveHeatmapReport = async (query: BaseReportFilters) => {
  const { body } = await api.get<HeatmapPitchRow[]>("/reports/heatmap/", {
    query: query,
  });

  return body;
};

export const useHeatmapReport = (
  filters: BaseReportFilters | Ref<BaseReportFilters>,
) => {
  return useQuery({
    queryKey: [REPORT_HEATMAP_QUERY_KEY, filters] as const,
    queryFn: ({ queryKey: [_, query] }) => retrieveHeatmapReport(unref(query)),
    staleTime: 60 * 60 * 1000,
    enabled: computed(() => !!unref(filters).siteId),
  });
};
